/**
 * Session status for project-home conversation rows and SSE liveness.
 *
 * Priority: local SSE running → waiting (attention / next-step) → idle.
 * Never invent list-wide running without a real local or backend signal.
 */

export type ConversationSessionStatus = "running" | "waiting" | "idle";

export interface DeriveConversationSessionStatusInput {
  /** Pending human-action hint from hub index enrichment. */
  attentionHint?: string | null;
  /** True only when this browser tab has an active SSE run for the conversation. */
  isRunningLocally?: boolean;
  /** True when the conversation appears in the loaded project next-steps set. */
  hasNextStep?: boolean;
}

/**
 * Derives the display status for an agent-session conversation row.
 *
 * @param input - Hub attention fields plus optional local running / next-step signals
 * @returns `running` | `waiting` | `idle`
 */
export function deriveConversationSessionStatus(
  input: DeriveConversationSessionStatusInput,
): ConversationSessionStatus {
  if (input.isRunningLocally) {
    return "running";
  }
  if (input.attentionHint != null || input.hasNextStep) {
    return "waiting";
  }
  return "idle";
}
